import {useState, useRef, useEffect} from 'react';
import {BottomBannerContentProps} from '../../type';

const PromotionBannerContent = ({
  bannerName,
  imagePath,
  link,
  handleLinkClick,
  handleClose,
  handleHide,
  target,
}: BottomBannerContentProps) => {
  const [isCheckedToday, setIsCheckedToday] = useState(false);
  const eventContentRef = useRef<HTMLDivElement>(null);

  const onCloseClicked = () => {
    if (isCheckedToday) {
      handleHide();
    } else {
      handleClose();
    }
  };

  useEffect(() => {
    if (eventContentRef.current) {
      const layerContainer =
        eventContentRef.current?.parentNode?.parentNode?.parentNode?.parentNode;

      if (layerContainer && (layerContainer as HTMLDivElement).style) {
        (layerContainer as HTMLDivElement).style.zIndex = '1500';
      }
    }
  }, []);

  return (
    // 320 * 450
    <div ref={eventContentRef} className='bnrimg_area'>
      <img alt={bannerName} src={imagePath} />
      <div className='btn_wrap'>
        <a
          className='more'
          href={link}
          target={target === 'Y' ? '_blank' : '_self'}
          onClick={handleLinkClick}>
          {bannerName}
        </a>
        <div className='close_days'>
          <input
            type='checkbox'
            id='hideToday'
            checked={isCheckedToday}
            onChange={(e) => setIsCheckedToday(e.target.checked)}
          />
          <label htmlFor='hideToday'>24시간 동안 보지 않기</label>
        </div>
      </div>
      <button type='button' className='btn_close' onClick={onCloseClicked}>
        닫기
      </button>
    </div>
  );
};

export default PromotionBannerContent;
